import { StringManager } from '@payments-checkout/shared/helpers/managers/string.manager';
import { FieldValues } from 'react-hook-form';

export const getBillingContactName = (billingContact?: {
  givenName?: string;
  familyName?: string;
}) => {
  const givenName = billingContact?.givenName;
  const familyName = billingContact?.familyName;

  if (givenName && familyName) return `${givenName} ${familyName}`;

  return givenName || familyName || '';
};

export const buildBillingAddress = (formValues: FieldValues) => ({
  address: {
    city: formValues['billing-address-city'] as string,
    state: formValues['billing-address-state'] as string,
    country: (formValues['billing-address-country'] as string) || 'BR',
    zip_code: formValues['billing-address-zip-code'] as string,
    neighborhood:
      StringManager.filledString(
        formValues['billing-address-district'] as string
      ) ?? '-',
    number:
      StringManager.filledString(
        formValues['billing-address-number'] as string
      ) ?? 'S/N',
    street: formValues['billing-address-street'] as string,
  },
});
